<div [ngClass]="Theme">
    <ul>
      <ng-content select="[list-item-content]"></ng-content>
    </ul>
  </div>